function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { fromLiteral, toLiteral } from "../../conversion.mjs";
import { propertyDecorator } from "./decoratorFactory.mjs";
export default function (options = {}) {
  const type = options.type || String;
  return propertyDecorator(_objectSpread(_objectSpread({}, options), {}, {
    fromTerm(obj) {
      return fromLiteral(type, obj);
    },

    toTerm(value) {
      return toLiteral(value, options.datatype);
    },

    valueTypeName: type.name,
    assertSetValue: value => {
      if (value instanceof Date) {
        return true;
      }

      if (typeof value === 'object') {
        let term;

        if ('id' in value) {
          return false;
        }

        if ('term' in value) {
          term = value.term;
        } else {
          term = value;
        }

        return term.termType === 'Literal';
      }

      return true;
    },

    compare(left, right) {
      return left === right;
    }

  }));
}